import { render, staticRenderFns } from "./avgTotalMessagesPerSession.vue?vue&type=template&id=264837e7&scoped=true&"
import script from "./avgTotalMessagesPerSession.vue?vue&type=script&lang=js&"
export * from "./avgTotalMessagesPerSession.vue?vue&type=script&lang=js&"
import style0 from "./avgTotalMessagesPerSession.vue?vue&type=style&index=0&id=264837e7&scoped=true&lang=css&"
import style1 from "./avgTotalMessagesPerSession.vue?vue&type=style&index=1&lang=scss&"
import style2 from "@/assets/css/bs-helpers.css?vue&type=style&index=2&id=264837e7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264837e7",
  null
  
)

export default component.exports